import { StepLabel, StepLabelProps } from '@mui/material';
import { BrightyStepIcon } from './BrightyStepIcon';

export function BrightyStepLabel({ children, ...props }: StepLabelProps) {
  return (
    <StepLabel
      {...props}
      slots={{
        ...props.slots,
        stepIcon: BrightyStepIcon,
      }}
    >
      {children}
    </StepLabel>
  );
}
